export const SurveyCreatorCustomTheme = {
  themeName: "custom",
  cssVariables: {
    "--sjs-layer-1-background-500": "#FFFFFFFF",
    "--sjs-layer-1-background-400": "#E6EBF9FF",
    "--sjs-layer-1-foreground-100": "#122243FF",
    "--sjs-layer-1-foreground-50": "#617082",
    "--sjs-layer-3-background-500": "#00000",
    "--sjs-layer-3-foreground-100": "#273859FF",
    "--sjs-layer-3-foreground-50": "#065990",
    "--sjs-layer-2-background-500": "#F2F6FDFF",
    "--sjs-layer-2-background-400": "#DAE2F7FF",
    "--sjs-special-haze": "rgba(255, 255, 255, 0.5)",
    "--sjs-border-25": "#C2CEE6FF",
    "--sjs-border-10": "#CDD7EAFF",
    "--sjs-primary-background-500": "#173357",
    "--sjs-primary-background-10": "#0b8be326",
    "--sjs-primary-background-400": "#042480FF",
    "--sjs-primary-foreground-100": "#FFFFFF",
    "--sjs-primary-foreground-25": "red",
    "--sjs-secondary-background-500": "#0b8be3",
    "--sjs-secondary-foreground-100": "#FFFFFFFF",
    "--sjs-secondary-forecolor-25": "#FFFFFF40",
    "--sjs-semantic-red-background-500": "#0b8be3",
    "--sjs-semantic-red-foreground-100": "#FFFFFFFF",
    "--sjs-semantic-green-foreground-100": "#FFFFFFFF",
    "--sjs-semantic-blue-background-500": "#437FD9FF",
    "--sjs-semantic-blue-background-10": "#0b8be326",
    "--sjs-code-gray-700": "#B6B6B6FF",
    "--sjs-code-blue-500": "#326FCAFF",
    "--sjs-code-red-500": "#FFFFFF",
    "--sjs-code-purple-500": "#FFFFFF",
    "--sjs-code-gray-500": "#8A8A8AFF",
    "--sjs-special-background": "#f1f2f4",
    "--sjs-layer-1-foreground-75": "#0930A0FF",
    "--sjs-layer-3-background-400": "#D3DDF5FF",
    "--sjs-special-glow": "#27385933",
    "--sjs-special-shadow": "#27385940",
    "--sjs-layer-3-foreground-75": "#0930A0FF",
    "--sjs-layer-2-foreground-100": "#273859FF",
    "--sjs-layer-2-foreground-75": "#0930A0FF",
    "--sjs-layer-2-foreground-50": "#26335880",
    "--sjs-border-25-overlay": "#00000026",
    "--sjs-secondary-background-400": "red",
    "--ctr-survey-page-border-color-hovered": "#0b8be380",
    "--ctr-survey-question-panel-border-color-hovered": "#0b8be380",
    "--ctr-editor-background-color": "#FFFFFF",
    "--ctr-survey-header-text-title-color-placeholder": "#065990",
    "--ctr-survey-page-header-title-color-placeholder": "#617082",
    "--ctr-survey-header-text-description-color-placeholder": "#065990",
    "--ctr-button-text-color": "#086cb0",
    "--ctr-button-text-color-hovered": "#FFFFFF",
    "--ctr-button-background-color-hovered": "#0b8be3",
    "--sjs-general-backcolor-dark": "#ebecf0",
    "--sjs-general-backcolor-dim-light": "#f1f2f4",
    "--sjs-editorpanel-cornerRadius": "0px",
    "--sjs-shadow-inner": "none",
    "--ctr-checkbox-border-color": "#0b8be3",
    "--sjs-corner-radius-x075": "0px",
    "--ctr-list-item-corner-radius": "0px",
    "--ctr-popup-menu-corner-radius": "0px",
    "--ctr-button-group-item-text-color-selected": "#FFFFFF",
    "--ctr-button-group-item-background-color-selected": "#0b8be3",
    "--ctr-button-group-background-color": "#173357",
    "--ctr-button-group-item-text-color": "#FFFFFF",
    "--ctr-button-group-item-background-color": "#173357",
    "--ctr-button-contextual-button-background-color-hovered": "#f1f2f4",
    "--ctr-button-group-item-background-color-hovered": "#45658d",
    "--ctr-button-group-item-border-color": "#0b8be3",
    "--sjs-semantic-yellow-background-10": "#1733570d",
    "--sjs-semantic-yellow-background-500": "#0b8be3",
    "--sjs-editorpanel-backcolor": "#f1f2f4",
    "--sjs-border-light": "rgba(0, 0, 0, 0)",
    "--ctr-popup-haze-background-color": "rgba(255, 255, 255, 0.5)",
    "--sjs-corner-radius-x1": "0px",
    "--ctr-menu-toolbar-button-background-color-selected": "transparent",
  },
};

export default SurveyCreatorCustomTheme;
